import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=8783fcf2&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=8783fcf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8783fcf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8783fcf2')) {
      api.createRecord('8783fcf2', component.options)
    } else {
      api.reload('8783fcf2', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=8783fcf2&scoped=true&", function () {
      api.rerender('8783fcf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g0abTc4RpKUY/JS/comp/PopupDialog.vue"
export default component.exports